import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MessagesContext } from '../../pages/NarrativePage/contexts/MessagesContext';
import { useContext, useEffect, useState } from 'react';
import { ampli } from "../../ampli";
import { CheckboxField } from '../Checkbox/CheckboxField';
import { ExpandableText } from '../CollapsibleText/ExpandableText';
import { Paginator } from '../Paginator/Paginator';
import { Loader } from '../Loader/Loader';
import { ReactComponent as ApproveIcon } from '../../pages/NarrativePage/assets/approve.svg';
import { ReactComponent as DeleteIcon } from '../../assets/delete.svg';
import { ReactComponent as RecoverIcon } from '../../assets/recover.svg';
import { ReactComponent as EnvelopeOpenIcon } from '../../assets/envelopeOpen.svg';
import { ReactComponent as HeartSolidIcon } from '../../assets/heart-solid.svg';
import { ReactComponent as HeartRegularIcon } from '../../assets/heart-regular.svg';
import { MessageModal } from './MessageModal';
import { MessageInfoWrapper } from './MessageInfoWrapper';
import { MessageTooltips } from './MessageTooltips';
import { MessageMetricsWrapper } from './MessageMetricsWrapper';
import { OriginalTextBlock } from './OriginalTextBlock';
import { useCurrentUser } from '../../contexts/CurrentUser';
import { areAllIdsSelected } from '../../pages/NarrativePage/contexts/MessagesContext';
import { replaceNewlinesWithBreaks } from '../../utils/replaceNewlinesWithBreaks';
import { ImagesContainer} from '../Image/ImagesContainer';
import { LoaderSmall } from '../LoaderSmall/LoaderSmall';
import Tooltip from '../Tooltip/Tooltip';
import { TranslationSwitch } from '../TranslationSwitch/TranslationSwitch';
import { formatNumber } from '../../utils/fomatNumbers';

import styles from './ExtendedMessageView.module.scss';


export const ExtendedMessageView = ({
  narrative,
  searchQuery,
  sorting,
  statuses,
  showOnlyFavorites,
  page,
  searchPanel,
  start,
  end,
  platforms,
  sourceGroups,
  isValid,
  languages,
  sources,
  countries,
  sentiment,
  contentTypes,
  cursor,
  setCursor,
  setPage,
  isShare = false,
  showOnlyBots,
  discreditations,
  affiliationCountries,
  affiliationTypes,
  affiliationTypesExclude,
  feeds,
  geoGroup,
  languagesExclude,
  countriesExclude,
  sourceGroupsExclude,
  sourcesExclude,
  affiliationCountriesExclude,
  feedsExclude,
  geoGroupExclude,
  botsExclude,
  discreditationsExclude,
  tags,
  tagsExclude,
}) => {
  const {
    messages,
    selectedMessages,
    getMessages,
    toggleAll,
    toggleSelected,
    deduplication,
    patchMessages,
    toggleFavotireMessage,
    deleteMessages,
    translateMessage,
    toggleTranslate,
    error,
    toggleTab,
    isSearchApplied,
    isLoading,
    dispatch,
    cancelRequest,
    areAllMessagesSelected,
    toggleSelectAllMessagesInCase,
    clearAllSelectedMessages,
    validationError,
    handleBulkTranslateClick,
    isBulkTranslation,
    isBulkTranslationLoading,
    handleShowOriginalClick,
    cancelTranslateAll,
  } = useContext(MessagesContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();

  const [messageModal, setMessageModal] = useState({message: null, isOpen: false, narrartiveMessage: null});
  const [selectAllNarrativeMessages, setSelectAllNarrativeMessages] = useState(false);
  const [isMessageDropdownOpen, setIsMessageDropdownOpen] = useState({});
  const [isMessageStatusChanging, setIsMessageStatusChanging] = useState(false);

  const featureFlags = currentUser?.workspace?.config.featureflags;
  const showSiilaritySearch = featureFlags?.includes('show_similarity_search');
  const enableDeepFakeDetector = featureFlags?.includes('deepfake_checker');

  useEffect(() => {
    if (isSearchApplied) {
      if (messages === null) {
        dispatch({ type: 'IS_BULK_TRANSLATION', isBulkTranslation: false });
        dispatch({ type: 'BULK_TRANSLATION_LOADING', isBulkTranslationLoading: false });
        return
      }
      if (messages?.cursor !== null && isBulkTranslation) {
        handleBulkTranslateClick(nativeLanguage);
      }
    } else {
      if (isBulkTranslation && (messages?.page && messages?.cursor === null)) {
        dispatch({ type: 'IS_BULK_TRANSLATION', isBulkTranslation: false });
        dispatch({ type: 'BULK_TRANSLATION_LOADING', isBulkTranslationLoading: false });
      } 
    }
  }, [messages?.cursor, messages?.page]);

  const nativeLanguage = currentUser?.translation_language
    ? currentUser?.translation_language
    : narrative.parameters?.translate_keywords_query
    ? narrative.parameters.keywords_query_origin_language
    : window.clientInformation.language.split('-', 1)[0];

  useEffect(() => {
    setPage(1);
    setCursor(null);
    toggleTab();
  }, [
    searchQuery,
    sorting,
    statuses,
    showOnlyFavorites,
    start,
    end,
    platforms,
    sourceGroups,
    languages,
    sources,
    countries,
    sentiment,
    contentTypes,
    showOnlyBots,
    discreditations,
    affiliationCountries,
    affiliationTypes,
    affiliationTypesExclude,
    feeds,
    geoGroup,
    languagesExclude,
    countriesExclude,
    sourceGroupsExclude,
    sourcesExclude,
    affiliationCountriesExclude,
    feedsExclude,
    geoGroupExclude,
    botsExclude,
    discreditationsExclude,,
    tags,
    tagsExclude,
  ]);

  let size = 100;


  useEffect(() => {
    if (isSearchApplied) {
      dispatch({ type: 'SET_LOADING', isLoading: true });
    } else dispatch({ type: 'TOGGLE_TAB' });

    if (
      (searchQuery === null || searchQuery?.trim().length === 0) &&
      messages
    ) {
      dispatch({ type: 'TOGGLE_TAB' });
    }
    getMessages(
      narrative,
      searchQuery,
      sorting,
      statuses,
      deduplication,
      page,
      showOnlyFavorites,
      start,
      end,
      platforms,
      sourceGroups,
      isValid,
      languages,
      sources,
      countries,
      sentiment,
      contentTypes,
      showOnlyBots,
      discreditations,
      affiliationCountries,
      feeds,
      geoGroup,
      languagesExclude,
      countriesExclude,
      sourceGroupsExclude,
      sourcesExclude,
      affiliationCountriesExclude,
      feedsExclude,
      geoGroupExclude,
      botsExclude,
      discreditationsExclude,
      tags,
      tagsExclude,
      // Sort/filters changed: always restart from the first page. The reset
      // effect above nulls `cursor` in state, but this effect runs in the same
      // commit and would still see the Load More cursor from props.
      null,
      isLoading,
      isSearchApplied,
      undefined,
      affiliationTypes,
      affiliationTypesExclude,
    );
  }, [
    searchQuery,
    sorting,
    statuses,
    showOnlyFavorites,
    start,
    end,
    platforms,
    sourceGroups,
    isValid,
    languages,
    sources,
    countries,
    sentiment,
    contentTypes,
    showOnlyBots,
    discreditations,
    affiliationCountries,
    affiliationTypes,
    affiliationTypesExclude,
    feeds,
    geoGroup,
    languagesExclude,
    countriesExclude,
    sourceGroupsExclude,
    sourcesExclude,
    affiliationCountriesExclude,
    feedsExclude,
    geoGroupExclude,
    botsExclude,
    discreditationsExclude,,
    tags,
    tagsExclude,
  ]);

  useEffect(() => {
    ampli.track({
      event_type: 'Open Messages tab',
      event_properties: {
        user_id: currentUser?.id,
        workspace_id: currentUser?.workspace_id,
        narrative_id: narrative.id,
      }
    });

    return () => {
      cancelRequest()
      cancelTranslateAll();
    }
  }, []);

  const handleTranslation = (messageId, text, isTranslation) => {
    const target = messages.objects.find((message) => message.id === messageId);
    const originalPostText =
      target?.content_type === 'COMMENT' ? target?.parent_message?.highlighted_text || target?.parent_message?.text : '';
    if (target.translated) {
      toggleTranslate(messageId, isTranslation);
    } else {

      toggleTranslate(messageId, true);

      if (originalPostText) {
        Promise.allSettled([
          translateMessage(messageId, originalPostText, nativeLanguage),
          translateMessage(messageId, text, nativeLanguage),
        ]).then((results) => {
          if (results[0].status === 'fulfilled') {
            const originalPostData = results[0].value;
            dispatch({
              type: 'TRANSLATE_ORIGINAL_POST',
              payload: { data: originalPostData, messageId: messageId },
            });
          } else {
            dispatch({
              type: 'TRANSLATION_ERROR_ORIGINAL_POST',
              payload: {
                data: t('We were not able to translate this text.'),
                messageId: messageId,
              },
            });
          }

          if (results[1].status === 'fulfilled') {
            const messageData = results[1].value;
            dispatch({
              type: 'TRANSLATE_MESSAGE',
              payload: { data: messageData, messageId: messageId },
            });
          } else {
            dispatch({
              type: 'TRANSLATION_ERROR',
              payload: {
                data: t('We were not able to translate this text.'),
                messageId: messageId,
              },
            });
          }
        });
      } else {
        translateMessage(messageId, text, nativeLanguage)
          .then((data) => {
            dispatch({
              type: 'TRANSLATE_MESSAGE',
              payload: { data: data, messageId: messageId },
            });
          })
          .catch((e) => {
            dispatch({
              type: 'TRANSLATION_ERROR',
              payload: {
                data: t('We were not able to translate this text.'),
                messageId: messageId,
              },
            });
          });
      }

      ampli.track({
        event_type: 'Translate message',
        event_properties: {
          user_id: currentUser?.id,
          workspace_id: currentUser?.workspace_id,
          narrative_id: narrative?.id,
        },
      });
    }
  };

  const [highlights, setHighlights] = useState(['KEYWORDS']);
  const [modalHighlights, setModalHighlights] = useState([]);
  const [highlightsMenu, setHighlightsMenu] = useState(false);

  if (!narrative) {
    return <Loader />;
  }

  const pagination_block =
      messages?.cursor != null && messages?.objects?.length < messages?.total ?
        <button
            className={styles.loadMore}
            disabled={isLoading}
            onClick={(e) => {
              e.preventDefault();
              setCursor(messages?.cursor)
              dispatch({type: 'SET_LOADING', isLoading: true});

              getMessages(
                narrative,
                searchQuery,
                sorting,
                statuses,
                deduplication,
                page,
                showOnlyFavorites,
                start,
                end,
                platforms,
                sourceGroups,
                isValid,
                languages,
                sources,
                countries,
                sentiment,
                contentTypes,
                showOnlyBots,
                discreditations,
                affiliationCountries,
                feeds,
                geoGroup,
                languagesExclude,
                countriesExclude,
                sourceGroupsExclude,
                sourcesExclude,
                affiliationCountriesExclude,
                feedsExclude,
                geoGroupExclude,
                botsExclude,
                discreditationsExclude,
                tags,
                tagsExclude,
                messages?.cursor,
                isLoading,
                isSearchApplied,
                undefined,
                affiliationTypes,
                affiliationTypesExclude,
              )
            }}
        >{ isLoading ? <LoaderSmall /> : t('Load More') }</button> : '';


  return (
    <>
      {searchPanel ? searchPanel : ''}
      {error ? (
        <div className={styles.error}>
          {error && validationError ? validationError : error}
        </div>
      ) : !messages ? (
        <Loader />
      ) : messages?.objects?.length > 0 ? (
        <table className={`${styles.extendedMessages} narrative-page-messages`}>
          <thead>
            <tr>
              <td className="message-controlls">
                {currentUser?.is_super_admin === true ||
                (!isShare &&
                  ((narrative.is_threat &&
                    narrative.review_status === 'PENDING') ||
                    !narrative.is_threat)) ? (
                  <CheckboxField
                    onChange={() => {
                      toggleAll(messages, selectedMessages);
                      if (areAllMessagesSelected) {
                        toggleSelectAllMessagesInCase(false);
                        clearAllSelectedMessages();
                      }
                    }}
                    checked={
                      areAllMessagesSelected ||
                      areAllIdsSelected(messages.objects, selectedMessages)
                    }
                  />
                ) : (
                  ''
                )}
              </td>
              <td className={styles.headerInfo}>
                {!areAllIdsSelected(messages.objects, selectedMessages) &&
                !areAllMessagesSelected ? (
                  <span>
                    {t('Total publications')}: {formatNumber(messages.total)}
                  </span>
                ) : !areAllMessagesSelected ? (
                  <div className={styles.selectAllContainer}>
                    <span>
                      {t('allPageMessagesSelected', {
                        count: messages?.objects?.length,
                      })}
                    </span>
                    <span
                      className={styles.selectAllMessages}
                      onClick={() => {
                        toggleSelectAllMessagesInCase(true);
                      }}
                    >
                      {t('selectAllMessages', {
                        count: messages?.total,
                      })}
                    </span>
                  </div>
                ) : (
                  <div className={styles.selectAllContainer}>
                    <span>
                      {t('allMessagesSelected', {
                        count: messages.total,
                      })}
                    </span>
                    <span
                      className={styles.selectAllMessages}
                      onClick={() => {
                        toggleSelectAllMessagesInCase(false);
                        toggleAll(messages, selectedMessages);
                      }}
                    >
                      {t('Deselect all')}
                    </span>
                  </div>
                )}
              </td>
              <td className="message-controlls">
                <div className={styles.translationSwitchWrapper}>
                  <TranslationSwitch
                    isBulkTranslation={true}
                    isTranslation={isBulkTranslation}
                    isLoading={isBulkTranslationLoading}
                    theme="dark"
                    size="medium"
                    isDisabled={isMessageStatusChanging}
                    handleTranslation={(bool) => {
                      if (bool) {
                        dispatch({
                          type: 'IS_BULK_TRANSLATION',
                          isBulkTranslation: bool,
                        });
                        handleBulkTranslateClick(nativeLanguage);
                        ampli.track({
                          event_type: 'Bulk Translation Click',
                          event_properties: {
                            user_id: currentUser?.id,
                            workspace_id: currentUser?.workspace_id,
                            narrative_id: narrative.id,
                            event_location: 'Case: messages tab',
                          },
                        });
                      } else {
                        dispatch({
                          type: 'IS_BULK_TRANSLATION',
                          isBulkTranslation: false,
                        });
                        handleShowOriginalClick();
                      }
                    }}
                  />
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            {messages.objects.map((message) => {
              let followers_cnt = message?.source?.audience;

              let textClass = styles.extendedMessage;
              let textClassParent = styles.extendedMessage;

              if (
                message.parent_message?.error &&
                message.parent_message?.isTranslation
              ) {
                textClassParent = `${styles.extendedMessage} ${styles.error}`;
              } else if (message.error && !message.isTranslation) {
                textClassParent = styles.extendedMessage;
              }

              if (message.error && message.isTranslation) {
                textClass = `${styles.extendedMessage} ${styles.error}`;
              } else if (message.error && !message.isTranslation) {
                textClass = styles.extendedMessage;
              }

              const narrartiveMessage = {
                narrative: narrative,
                page: page,
                searchQuery: searchQuery,
                sorting: sorting,
                statuses: statuses,
              };

              const textForTranslation = message.highlighted_text
                ? replaceNewlinesWithBreaks(message.highlighted_text)
                : replaceNewlinesWithBreaks(message.text);

              let messageMenuOptions = [];
              if (showSiilaritySearch) {
                messageMenuOptions.push({
                  name: t('Find similar publications'),
                  value: 'similar',
                });
              }

              if (
                (message?.content_type === 'COMMENT' &&
                  (message?.parent_message || message?.parent_id)) ||
                message?.content_type === 'POST'
              ) {
                messageMenuOptions.push({
                  name: t('Find comments to post'),
                  value: 'comments',
                });
              }

              if (
                message?.content_type === 'VIDEO' &&
                message?.source?.source_type === 'TIKTOK'
              ) {
                messageMenuOptions.push({
                  name: t('Find comments to video'),
                  value: 'comments_to_video',
                });
              }

              if (
                message?.content_type === 'POST' &&
                ['TIKTOK', 'FACEBOOK', 'TELEGRAM'].includes(message?.source?.source_type)
              ) {
                messageMenuOptions.push({
                  name: t('Find reposts to post'),
                  value: 'reposts_to_post',
                });
              }

              return (
                <tr key={message.id}>
                  <td className="message-controlls">
                    {currentUser?.is_super_admin === true ||
                    (!isShare &&
                      ((narrative.is_threat &&
                        narrative.review_status === 'PENDING') ||
                        !narrative.is_threat)) ? (
                      <CheckboxField
                        checked={
                          areAllMessagesSelected
                            ? true
                            : message.id in selectedMessages
                        }
                        onChange={() => toggleSelected(message.id)}
                        isDisabled={areAllMessagesSelected}
                      />
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    <MessageInfoWrapper
                      message={message}
                      followers_cnt={followers_cnt}
                      isShare={isShare}
                      currentUser={currentUser}
                      narrative={narrative}
                      narrartiveMessage={narrartiveMessage}
                      setMessageModal={setMessageModal}
                    />

                    <div className={styles.messageContainer}>
                      <MessageMetricsWrapper
                        message={message}
                        narrative={narrative}
                        isShare={isShare}
                        isMessageDropdownOpen={isMessageDropdownOpen}
                        setIsMessageDropdownOpen={setIsMessageDropdownOpen}
                        messageMenuOptions={messageMenuOptions}
                      />

                      {message.parent_message ? (
                        <OriginalTextBlock
                          message={message}
                          isShare={isShare}
                          currentUser={currentUser}
                          narrative={narrative}
                          textClassParent={textClassParent}
                          enableDeepFakeDetector={enableDeepFakeDetector}
                        />
                      ) : (
                        ''
                      )}

                      {message?.images && message?.images?.length > 0 ? (
                        <ImagesContainer
                          images={message?.images}
                          showCount={3}
                          enableDeepFakeDetector={enableDeepFakeDetector}
                        />
                      ) : (
                        ''
                      )}

                      <div className={styles.textBlock}>
                        {message.isTranslation === true &&
                        !message.translated ? (
                          <div className={styles.loaderContainer}>
                            <LoaderSmall />
                          </div>
                        ) : (
                          <ExpandableText
                            length={150}
                            highlights={highlights}
                            text={
                              message.isTranslation
                                ? message.translated
                                : message.highlighted_text || message.text
                            }
                            textClassName={textClass}
                            onExpand={(expanded) => {
                              ampli.track({
                                event_type: expanded
                                  ? 'Expand message in-place'
                                  : 'Collapse message in-place',
                                event_properties: {
                                  user_id: currentUser?.id,
                                  workspace_id: currentUser?.workspace_id,
                                  narrative_id: narrative.id,
                                },
                              });
                            }}
                          />
                        )}
                        {narrative.is_threat || isShare ? (
                          ''
                        ) : (
                          <div
                            className={
                              isBulkTranslationLoading
                                ? styles.favoritesDisabled
                                : styles.favorites
                            }
                          >
                            <span
                              className="open-message-popup"
                              onClick={() => {
                                if (isBulkTranslationLoading) {
                                  return;
                                }
                                setIsMessageStatusChanging(true);
                                toggleFavotireMessage(
                                  narrative,
                                  !message.favorite,
                                  [message.id],
                                  deduplication,
                                ).then(() => {
                                  if (!showOnlyFavorites) {
                                    // There is no need to fetch messages if the showOnlyFavorites is not applied
                                    return;
                                  }
                                  dispatch({
                                    type: 'IS_BULK_TRANSLATION',
                                    isBulkTranslation: false,
                                  });
                                  getMessages(
                                    narrative,
                                    searchQuery,
                                    sorting,
                                    statuses,
                                    deduplication,
                                    page,
                                    showOnlyFavorites,
                                    start,
                                    end,
                                    platforms,
                                    sourceGroups,
                                    isValid,
                                    languages,
                                    sources,
                                    countries,
                                    sentiment,
                                    contentTypes,
                                    showOnlyBots,
                                    discreditations,
                                    affiliationCountries,
                                    feeds,
                                    geoGroup,
                                    languagesExclude,
                                    countriesExclude,
                                    sourceGroupsExclude,
                                    sourcesExclude,
                                    affiliationCountriesExclude,
                                    feedsExclude,
                                    geoGroupExclude,
                                    botsExclude,
                                    discreditationsExclude,
                                    tags,
                                    tagsExclude,
                                    cursor,
                                    isLoading,
                                    isSearchApplied,
                                    undefined,
                                    affiliationTypes,
                                    affiliationTypesExclude,
                                  );
                                  setIsMessageStatusChanging(false);
                                });
                              }}
                            >
                              {message.favorite ? (
                                <Tooltip
                                  content={t('Delete from favorites')}
                                  position="bottom"
                                >
                                  <HeartSolidIcon />
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  content={t('Add to favorites')}
                                  position="bottom"
                                >
                                  <HeartRegularIcon />
                                </Tooltip>
                              )}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="message-controlls">
                    {isShare ? (
                      ''
                    ) : (
                      <>
                        {currentUser?.is_super_admin === true ||
                        (!isShare &&
                          ((narrative.is_threat &&
                            narrative.review_status === 'PENDING') ||
                            !narrative.is_threat)) ? (
                          <div className={styles.controls}>
                            <button
                              className={`${styles.approve} btn-primary`}
                              disabled={
                                message.status === 'DELETED' ||
                                isBulkTranslationLoading
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                let status =
                                  message.status === 'NEW' ? 'READ' : 'NEW';
                                let messageIds = [message.id];
                                setIsMessageStatusChanging(true);
                                patchMessages(
                                  narrative,
                                  status,
                                  messageIds,
                                  deduplication,
                                ).then(() => {
                                  dispatch({ type: 'PATCH_MESSAGES' });
                                  dispatch({
                                    type: 'IS_BULK_TRANSLATION',
                                    isBulkTranslation: false,
                                  });
                                  getMessages(
                                    narrative,
                                    searchQuery,
                                    sorting,
                                    statuses,
                                    deduplication,
                                    page,
                                    showOnlyFavorites,
                                    start,
                                    end,
                                    platforms,
                                    sourceGroups,
                                    isValid,
                                    languages,
                                    sources,
                                    countries,
                                    sentiment,
                                    contentTypes,
                                    showOnlyBots,
                                    discreditations,
                                    affiliationCountries,
                                    feeds,
                                    geoGroup,
                                    languagesExclude,
                                    countriesExclude,
                                    sourceGroupsExclude,
                                    sourcesExclude,
                                    affiliationCountriesExclude,
                                    feedsExclude,
                                    geoGroupExclude,
                                    botsExclude,
                                    discreditationsExclude,
                                    tags,
                                    tagsExclude,
                                    cursor,
                                    isLoading,
                                    isSearchApplied,
                                    undefined,
                                    affiliationTypes,
                                    affiliationTypesExclude,
                                  );
                                  setIsMessageStatusChanging(false);
                                });
                              }}
                            >
                              {message.status === 'NEW' ? (
                                <ApproveIcon />
                              ) : (
                                <EnvelopeOpenIcon />
                              )}
                            </button>
                            <button
                              className={`${styles.delete} btn-danger`}
                              disabled={isBulkTranslationLoading}
                              onClick={() => {
                                let messageIds = [message.id];
                                if (message.status === 'DELETED') {
                                  setIsMessageStatusChanging(true);
                                  patchMessages(
                                    narrative,
                                    'NEW',
                                    messageIds,
                                    deduplication,
                                  ).then(() => {
                                    dispatch({ type: 'PATCH_MESSAGES' });
                                    dispatch({
                                      type: 'IS_BULK_TRANSLATION',
                                      isBulkTranslation: false,
                                    });
                                    getMessages(
                                      narrative,
                                      searchQuery,
                                      sorting,
                                      statuses,
                                      deduplication,
                                      page,
                                      showOnlyFavorites,
                                      start,
                                      end,
                                      platforms,
                                      sourceGroups,
                                      isValid,
                                      languages,
                                      sources,
                                      countries,
                                      sentiment,
                                      contentTypes,
                                      showOnlyBots,
                                      discreditations,
                                      affiliationCountries,
                                      feeds,
                                      geoGroup,
                                      languagesExclude,
                                      countriesExclude,
                                      sourceGroupsExclude,
                                      sourcesExclude,
                                      affiliationCountriesExclude,
                                      feedsExclude,
                                      geoGroupExclude,
                                      botsExclude,
                                      discreditationsExclude,
                                      tags,
                                      tagsExclude,
                                      cursor,
                                      isLoading,
                                      isSearchApplied,
                                      undefined,
                                      affiliationTypes,
                                      affiliationTypesExclude,
                                    );
                                    setIsMessageStatusChanging(false);
                                  });
                                } else {
                                  setIsMessageStatusChanging(true);
                                  deleteMessages(
                                    narrative,
                                    messageIds,
                                    deduplication,
                                  ).then(() => {
                                    dispatch({ type: 'DELETE_MESSAGES' });
                                    dispatch({
                                      type: 'IS_BULK_TRANSLATION',
                                      isBulkTranslation: false,
                                    });
                                    getMessages(
                                      narrative,
                                      searchQuery,
                                      sorting,
                                      statuses,
                                      deduplication,
                                      page,
                                      showOnlyFavorites,
                                      start,
                                      end,
                                      platforms,
                                      sourceGroups,
                                      isValid,
                                      languages,
                                      sources,
                                      countries,
                                      sentiment,
                                      contentTypes,
                                      showOnlyBots,
                                      discreditations,
                                      affiliationCountries,
                                      feeds,
                                      geoGroup,
                                      languagesExclude,
                                      countriesExclude,
                                      sourceGroupsExclude,
                                      sourcesExclude,
                                      affiliationCountriesExclude,
                                      feedsExclude,
                                      geoGroupExclude,
                                      botsExclude,
                                      discreditationsExclude,
                                      tags,
                                      tagsExclude,
                                      cursor,
                                      isLoading,
                                      isSearchApplied,
                                      undefined,
                                      affiliationTypes,
                                      affiliationTypesExclude,
                                    );
                                    setIsMessageStatusChanging(false);
                                  });
                                }
                              }}
                            >
                              {message.status === 'DELETED' ? (
                                <RecoverIcon />
                              ) : (
                                <DeleteIcon />
                              )}
                            </button>
                          </div>
                        ) : (
                          ''
                        )}
                      </>
                    )}

                    <div className={styles.translationWrapperNew}>
                      <TranslationSwitch
                        isTranslation={message.isTranslation}
                        theme="light"
                        size="medium"
                        handleTranslation={(bool) => {
                          handleTranslation(
                            message.id,
                            textForTranslation,
                            bool,
                          );
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className={styles.noData}>{t('There is no data to display')}</div>
      )}
      <MessageTooltips scope=".narrative-page-messages" />

      {messages?.objects?.length > 0 ? pagination_block : ''}

      {messageModal.isOpen ? (
        <MessageModal
          message={messageModal.message}
          isOpen={messageModal.isOpen}
          onChange={(bool, selected) => {
            setMessageModal({
              message: null,
              isOpen: bool,
              narrartiveMessage: null,
            });
            setModalHighlights(selected);
          }}
          narrativeMessage={messageModal.narrartiveMessage}
          selected={
            modalHighlights?.length === 0 ? highlights : modalHighlights
          }
          narrative={narrative}
          isShare={isShare}
        />
      ) : (
        ''
      )}
    </>
  );
}
